import { SET_SIDENAV } from '@/store/mutation_types';
import { CLEAR_SIDENAV, UPDATE_SIDENAV } from '@/store/action_types';

// Whether the sidenav rail is retracted to its icon column. Every page's
// content column reads it to claim the width the rail gives up.
const sidenav = {
  state: {
    isCollapsed: false,
  },
  getters: {
    isCollapsed: (state: { isCollapsed: boolean }) => state.isCollapsed,
  },
  mutations: {
    [SET_SIDENAV]: (state: { isCollapsed: boolean }, payload: boolean) => {
      state.isCollapsed = payload;
    },
  },
  actions: {
    [CLEAR_SIDENAV]: ({ commit }: any) => {
      commit(SET_SIDENAV, false);
    },
    [UPDATE_SIDENAV]: ({ commit }: any, payload: boolean) => {
      commit(SET_SIDENAV, payload);
    },
  },
};

export default sidenav;
